<template>
  <OareDialog
    v-if="viewingDraft"
    :title="`${viewingDraft.textName} Draft`"
    :width="1000"
    :show-submit="false"
    :show-cancel="false"
    :close-button="true"
    :persistent="false"
    :model-value="modelValue"
    @update:model-value="$emit('update:modelValue', $event)"
  >
    <span class="mb-2">
      <span class="font-weight-bold mr-1">Author Notes:</span>
      {{ viewingDraft.notes || 'No notes' }}
    </span>
    <code-diff
      :old-string="viewingDraft.originalText"
      :new-string="draftText"
      output-format="side-by-side"
    />
  </OareDialog>
</template>

<script lang="ts">
import { defineComponent, PropType, computed } from 'vue';
import { TextDraft } from '@oare/types';
import { CodeDiff } from 'v-code-diff';

export default defineComponent({
  name: 'DraftDiffPopup',
  components: {
    CodeDiff,
  },
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    viewingDraft: {
      type: Object as PropType<
        Pick<TextDraft, 'textName' | 'notes' | 'originalText' | 'content'>
      >,
      required: true,
    },
  },
  emits: ['update:modelValue'],
  setup(props) {
    const draftText = computed(() =>
      props.viewingDraft.content
        .map(({ side, text }) => `${side}\n${text}`)
        .join('\n')
    );

    return {
      draftText,
    };
  },
});
</script>
